export const playerData = {
    url: "https://cdn.staticfile.org/dplayer/1.27.1/DPlayer.min.js",
    loaded: false,
};
